/* ------------------------ style ------------------------ */
import style from "./style.module.scss";

/* ------------------------ plugin ------------------------ */
import { useState, useEffect, useMemo } from "react";

/* ------------------------ type ------------------------ */
import type { PreviewImagePropsType } from "../../index-type";

/* ------------------------ components ------------------------ */
import ResourceLoadError from "../ResourceLoadError";

/* ------------------------ utils ------------------------ */
import { imageUtil } from "@/utils/imageUtil";

const PreviewImage: React.FC<PreviewImagePropsType> = ({
  src,
  alt = '',
  trackExtraParams = { previewImage: {} },
  resourceOperateHandler,
  errorHandler
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [tryAgainTimes, setTryAgainTimes] = useState(0);

  const imgUrl = useMemo(() => {
    return imageUtil.concatImgUrlWithoutForceHttps(
      src,
      1400,
      0,
      100,
      process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(","),
    )
  }, [src]);

  useEffect(() => {
    const img = new Image();
    img.src = imgUrl;
    img.onload = () => { setIsLoading(false); };
    img.onerror = () => {
      setIsError(true);
      errorHandler();
    };
  }, [src, tryAgainTimes]);

  const handleTryAgain = () => {
    setIsError(false);
    setTryAgainTimes(tryAgainTimes + 1);
    resourceOperateHandler('tryAgain');
  }

  return (
    <div className={style.preview_image_container}>
      <ResourceLoadError
        isLoading={isLoading}
        isError={isError}
        {...(trackExtraParams?.tryAgainBtn ? { extraParams: trackExtraParams.tryAgainBtn } : {})}
        tryAgainHandler={handleTryAgain}
      />

      <img
        {...(trackExtraParams.previewImage)}
        className={`${style.image} ${isLoading ? style.hidden : ""}`}
        src={imgUrl}
        alt={alt}
        onLoad={() => setIsLoading(false)}
        onError={() => setIsError(true)}
      />
    </div>
  );
};

export default PreviewImage;
